import React, { useEffect, useState } from "react";
import NavFrontendSpinner from "nav-frontend-spinner";

import { phoneService } from "../../api";
import { GiftcardClaim } from "../../types";

const MAX_POLL_ATTEMPTS = 200; // ~10 min at 3s intervals — GoGift can take minutes to deliver the webhook

export const GiftcardStep = () => {
  const [claim, setClaim] = useState<GiftcardClaim | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    let poller: number;
    let attempts = 0;

    const scheduleRetry = () => {
      if (attempts >= MAX_POLL_ATTEMPTS) {
        setFailed(true);
        return;
      }
      poller = window.setTimeout(poll, 3000);
    };

    const poll = async () => {
      attempts += 1;
      try {
        const result = await phoneService.claimGiftcard();
        if (cancelled) return;
        setClaim(result);
        if (result.status === "pending") {
          scheduleRetry();
        }
      } catch {
        if (cancelled) return;
        scheduleRetry();
      }
    };
    poll();

    return () => {
      cancelled = true;
      window.clearTimeout(poller);
    };
  }, []);

  if (failed) {
    return (
      <>
        <h1>Dette tar tid</h1>
        <p>
          Dette tar lengre tid enn ventet.
          <br />
          Ta kontakt på <a href="mailto:elin.svensen@uis.no">elin.svensen@uis.no</a>{" "}
          og oppgi telefonnummeret ditt.
        </p>
      </>
    );
  }

  if (!claim || claim.status === "pending") {
    return (
      <>
        <h1>Henter gavekortet ditt</h1>
        <NavFrontendSpinner type="L" />
        <p>
          Ett øyeblikk …
          <br />
          Det kan ta litt tid før det er klart.
        </p>
      </>
    );
  }

  return (
    <>
      <h1>Her er gavekortet ditt!</h1>
      <div>Verdi: {claim.value} kr</div>
      <div>Pin: {claim.pin} (kopier denne koden før du åpner gavekortet)</div>
      <div>
        Gavekortet er gyldig til:{" "}
        {new Date(claim.expiry).toLocaleDateString("no")}
      </div>
      <br />
      <div>
        <b>Husk å laste det ned gavekortet med en gang.</b>
      </div>
      <div>
        <a
          href={claim.url}
          target="_blank"
          rel="noreferrer"
          className="knapp knapp--hoved"
        >
          Åpne gavekortet
        </a>
      </div>
    </>
  );
};
